module.exports = __webpack_public_path__ + "img/ph_presentation.73ab0546.svg";